module.exports = __webpack_public_path__ + "img/blue-building.17a45d1d.svg";